import errorBoundary from './ErrorBoundary'

export default errorBoundary
